import { ShopLink } from '../components/ShopLink';
import { useShopLinkService } from '../services/useShopLinkService';
export interface ShopLinkContainerProps {}

export const ShopLinkContainer: React.FC<React.PropsWithChildren<ShopLinkContainerProps>> = () => {
  const { shop_name, handleClickShop } = useShopLinkService();

  return <ShopLink shop_name={shop_name} onClick={handleClickShop} />;
};
